import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initializeAnalytics } from "./analytics";
import "./styles.css";

const PRELOAD_RECOVERY_KEY = "atlas:preload-recovery:v1";
const INITIAL_LOADING_COPY = /^\/uk(?:\/|$)/.test(window.location.pathname)
  ? "Завантаження Атласу"
  : /^\/ru(?:\/|$)/.test(window.location.pathname)
    ? "Загрузка Атласа"
    : "Loading Atlas";

const legacyEssaysRoute = window.location.pathname.match(/^\/(?:(uk|ru)\/)?essays\/?$/);
if (legacyEssaysRoute) {
  const languageRoot = legacyEssaysRoute[1] ? `/${legacyEssaysRoute[1]}/` : "/";
  window.history.replaceState(window.history.state, "", `${languageRoot}${window.location.search}#essays`);
}

window.addEventListener("vite:preloadError", (event) => {
  let previousRecovery = 0;
  try {
    previousRecovery = Number(sessionStorage.getItem(PRELOAD_RECOVERY_KEY) ?? 0);
  } catch {
    // Storage can be unavailable in hardened browsing modes.
  }
  if (Date.now() - previousRecovery < 30_000) return;
  event.preventDefault();
  try {
    sessionStorage.setItem(PRELOAD_RECOVERY_KEY, String(Date.now()));
  } catch {
    // Reload recovery does not depend on storage being available.
  }
  window.location.reload();
});
window.setTimeout(() => {
  try {
    sessionStorage.removeItem(PRELOAD_RECOVERY_KEY);
  } catch {
    // Storage can be unavailable in hardened browsing modes.
  }
}, 30_000);

initializeAnalytics();

const root = document.getElementById("root")!;
if (root.dataset.prerendered === "true") root.replaceChildren();

createRoot(root).render(
  <StrictMode>
    <Suspense
      fallback={(
        <div className="route-loading" role="status" aria-live="polite" aria-atomic="true" aria-busy="true">
          <span className="route-loading-label">{INITIAL_LOADING_COPY}</span>
        </div>
      )}
    >
      <App />
    </Suspense>
  </StrictMode>,
);
